import Dispatch from '../core/Dispatch';
import { VIEWPORTHEIGHT_CHANGE } from './events';

let isScrolling = false;
let lastPortrait = 0;
let lastLandscape = 0;
let pixelRatio = window.devicePixelRatio;
let prevValue;

const update = value => {
    document.documentElement.style.setProperty('--vh', `${value * 0.01}px`);
    if (value !== prevValue) {
        Dispatch.emit(VIEWPORTHEIGHT_CHANGE);
        prevValue = value;
    }
};

const setLastValues = () => {
    if (window.innerWidth > window.innerHeight) {
        lastLandscape = window.innerHeight;
    } else {
        lastPortrait = window.innerHeight;
    }
};

const getLastValues = () => {
    if (window.innerWidth > window.innerHeight) {
        return lastLandscape || window.innerHeight;
    }
    return lastPortrait || window.innerHeight;
};

const getScrollTop = () => {
    return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
};

const orientationchange = () => {
    setTimeout(() => {
        const scrollTop = getScrollTop();
        window.scrollTo(0, -100);
        setTimeout(() => {
            update(getLastValues());
            window.scrollTo(0, scrollTop);
        });
    }, 60);
};

const resize = () => {
    if (!isScrolling) {
        update(window.innerHeight);
        setLastValues();
    }
};

const scrollTouchOrMove = () => {
    requestAnimationFrame(() => {
        window.clearTimeout(isScrolling);
        // Check the device pixel ratio to avoid the `isScrolling` timeout to be set (which will prevent the resize handler from executing) if the user zooms their browser
        if (window.devicePixelRatio !== pixelRatio) {
            pixelRatio = window.devicePixelRatio;
            return;
        }
        isScrolling = setTimeout(() => {
            isScrolling = 0;
        }, 120);
    });
};

const init = () => {

    window.addEventListener('scroll', scrollTouchOrMove, { capture: false, passive: true });
    window.addEventListener('touchstart', scrollTouchOrMove, { capture: false, passive: true });
    window.addEventListener('touchmove', scrollTouchOrMove, { capture: false, passive: true });
    window.addEventListener('touchend', scrollTouchOrMove, { capture: false, passive: true });

    window.addEventListener('resize', () => {
        requestAnimationFrame(resize);
    }, { capture: false, passive: true });

    window.addEventListener('orientationchange', () => {
        requestAnimationFrame(orientationchange);
    }, { capture: false, passive: true });

    resize();
};

export default {
    init
};
